module.exports = __webpack_public_path__ + "static/media/rapipago.a60fae0a.svg";